"use client";
import { Tab, Tabs } from "react-bootstrap";
import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { Black, hover } from "@/styles/globalStyleVars";
import Select, { components } from "react-select";
import MediaListing from "@/components/media/MediaListing";
import DownloadListing from "@/components/media/DownloadListing";
import { usePathname, useRouter } from "next/navigation";
import { gsap } from "gsap";
import ThemeContainer from "@/components/theme/container";
import OurExpert from "@/components/media/OurExpert";
import { getApiHUB } from "@/api";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);

const MediaFilter = ({ mediaList, downloadHub, expertList }) => {
  const pathname = usePathname();
  const [offset, setOffset] = useState(0);
  const router = useRouter();
  useEffect(() => {
    const handleResize = () => {
      setOffset(document.querySelector(".footer .container").offsetLeft);
    };

    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("load", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, [pathname]);

  const [deviceWidth, setDeviceWidth] = useState(0);

  useEffect(() => {
    function HandleWidth() {
      setDeviceWidth(window.innerWidth);
    }

    window.addEventListener("resize", HandleWidth);
    HandleWidth();
    return () => {
      window.removeEventListener("resize", HandleWidth);
    };
  }, []);

  useEffect(() => {
    if (offset > 0) {
      gsap.to(".media-filter", {
        opacity: 1,
      });
    }
  }, [offset]);

  const customStyles = {
    dropdownIndicator: (base, state) => ({
      ...base,
      transition: "all .2s ease",
      // transform: state.selectProps.menuIsOpen && "rotate(180deg)"
    }),
    option: (provided, state) => ({
      ...provided,
      borderRadius: 0,
      color: state.isSelected ? `${hover}` : "#221F1F",
      backgroundColor: state.isSelected ? `rgba(232, 231, 231, 0.6)` : "#FFF",
      margin: 0,
      fontSize: 14,
      cursor: "pointer",
      paddingLeft: 10,
      paddingRight: 10,
      fontWeight: state.isSelected ? 600 : 400,
      "&:hover": {
        backgroundColor: `rgba(232, 231, 231, 0.8)`,
        color: "#FFF",
        cursor: "pointer",
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      color: "#FFF",
      backgroundColor: state.isSelected ? `${hover}` : "rgba(255,255,255,0)",
      margin: 0,
      borderRadius: 0,
      fontSize: 14,
      zIndex: 10,
      // width: 200,
    }),
    menuList: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? `${hover}` : "#FFF",
      borderRadius: 0,
      fontWeight: "400",
      color: "#FFF",
      // fontSize: 14,
    }),
  };

  const options = [
    { value: "media", label: "News & Events" },
    { value: "download", label: "Download HUB" },
    { value: "expert", label: "Our Expert" },
  ];

  const CaretDownIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13.414"
        height="7.414"
        viewBox="0 0 13.414 7.414"
      >
        <g
          id="Group_15659"
          data-name="Group 15659"
          transform="translate(1479.207 -192.793) rotate(90)"
        >
          <line
            id="Line_3883"
            data-name="Line 3883"
            x2="6"
            y2="6"
            transform="translate(193.5 1466.5)"
            fill="none"
            stroke="#FFFFFF"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <line
            id="Line_3884"
            data-name="Line 3884"
            y1="6"
            x2="6"
            transform="translate(193.5 1472.5)"
            fill="none"
            stroke="#FFFFFF"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </g>
      </svg>
    );
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    );
  };

  const [activeKey, setActiveKey] = useState("media");
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    setActiveKey(hash || "media"); // Default to 'media' if no hash
  }, [pathname, router.asPath]);

  const handleSelect = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "media";
    router.push(`/ucb-hub#${value}`);
    setActiveKey(value);
  };

  useEffect(() => {
    const getA = document.querySelectorAll(".Main-menu__open__items a");
    getA.forEach((e) => {
      e.addEventListener("click", (f) => {
        setTimeout(() => {
          if (window.location.hash) {
            const hash = window.location.hash.replace("#", "");
            setActiveKey(hash || "media");
          }
        }, 300);
      });
    });
  }, []);

  return (
    <StyledMediaFilter
      className="media-filter"
      offset={offset}
      style={{ paddingLeft: offset + "px" }}
    >
      <ThemeContainer fluid colProps={{ md: 12 }}>
        <div className="media-filter__mobile">
          <Select
            classNamePrefix="filter"
            onChange={(e) => handleSelect(e)}
            isSearchable={false}
            styles={customStyles}
            components={{ DropdownIndicator }}
            options={options}
            placeholder={"All"}
            value={options.find((option) => option.value === activeKey)} // Ensure Select displays the correct value
          />
        </div>
        <Tabs
          activeKey={activeKey}
          onSelect={(k) => {
            setActiveKey(k);
            router.push(`#${k}`);
            const position = 400;
            gsap.to(window, {
              duration: 1,
              scrollTo: position,
            });
          }}
          id="uncontrolled-tab-example"
          className="mb-3 media-filter__desktop"
        >
          <Tab eventKey="media" id={"media"} title="News & Events">
            <MediaListing data={mediaList} />
          </Tab>
          <Tab eventKey="download" id={"download"} title="Download HUB">
            <DownloadListing data={downloadHub} />
          </Tab>
          <Tab eventKey="expert" id={"expert"} title="Our Experts">
            <OurExpert data={expertList?.experts} />
          </Tab>
        </Tabs>
      </ThemeContainer>
    </StyledMediaFilter>
  );
};

const StyledMediaFilter = styled.section`
  // padding-left: ${(props) => (props.offset ? props.offset + "px" : "140px")};
  background-color: #f4f4f4;
  margin-top: -46px;
  overflow: hidden;

  .container-fluid {
    padding: 0;
  }

  .media-filter__desktop {
    padding-top: 30px;
    padding-bottom: 30px;
    display: flex;
    gap: 70px;
    background: ${Black};
    padding-left: 100px;
    margin-bottom: 0;

    li {
      button {
        font-size: 24px;
        line-height: 32px;
        color: rgba(255, 255, 255, 0.5);
        padding: 0;
        border-top-left-radius: unset;
        border-top-right-radius: unset;
        border: none !important;

        &.active {
          background-color: transparent !important;
          color: #fff !important;
        }
      }
    }
  }

  .media-filter__mobile {
    .css-13cymwt-control {
      border-radius: 0px !important;
      border: 1px solid #191919 !important;

      &:hover {
        border: 1px solid #191919 !important;
      }
    }

    .css-1u9des2-indicatorSeparator {
      background-color: transparent;
    }

    .css-1dimb5e-singleValue {
      font-size: 18px;
      line-height: 24px;
      font-weight: 400;
      color: White !important;
      padding-top: 10px;
    }

    .css-1jqq78o-placeholder {
      font-size: 24px;
      line-height: 32px;
      font-weight: 400;
      padding-top: 10px;
      color: White !important;
      padding-left: 0px !important;
    }

    .css-yk16xz-control .css-1wa3eu0-placeholder,
    .css-1pahdxg-control .css-1wa3eu0-placeholder,
    .css-1uccc91-singleValue {
      color: #3c4348 !important;
      font-size: 16px !important;
      font-weight: bold;
      cursor: pointer;
      letter-spacing: 2px !important;
      text-transform: capitalize !important;
    }

    .filter__single-value.css-1dimb5e-singleValue {
      text-transform: capitalize;
      padding-left: 0px !important;
      padding-top: 0;
    }

    .css-1s4cg4l-indicatorContainer {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: White !important;
      margin-right: 5px !important;
    }

    .filter__control {
      border-radius: 0 !important;
      background-color: #191919 !important;
      height: 60px;

      &--menu-is-open {
        border-radius: 0 !important;
        background-color: #191919 !important;
      }
    }

    .filter__dropdown-indicator {
      margin-right: 5px !important;
    }
    .css-t3ipsp-control {
      box-shadow: none !important;
      border-color: unset !important;
    }

    .css-1fdsijx-ValueContainer {
      padding: 30px 15px;
    }
  }

  .tab-content {
    padding-right: ${(p) => p.offset}px;
  }

  .media-filter__desktop {
    @media (max-width: 767px) {
      display: none;
    }
  }
  .media-filter__mobile {
    display: none;
    @media (max-width: 767px) {
      display: block;
    }
  }

  @media (max-width: 767px) {
    margin-top: 0;
    padding-left: 0;
  }
`;
export default MediaFilter;
